<template>
  <model-table
    :collection="paymentConnectorLogs"
    :show-add="false"
    :edit-mode="false"
    :columns="[
      { field: 'id' },
      { field: 'command' },
      { field: 'error', label: 'Message' },
      { field: 'createdAt', component: 'date-time' },
      { field: 'updatedAt', component: 'date-time' },
      { field: 'logData' },
    ]"
  />
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'

export default {
  name: 'PaymentConnectorLogTable',
  components: {
    ModelTable
  },
  props: {
    paymentConnectorConfigurationId: {
      type: Number,
      required: false,
      default: null
    }
  },
  context: ['currentUser'],
  models: {
    paymentConnectorLogs: {
      variables () {
        return {
          paymentConnectorConfigurationId: this.paymentConnectorConfigurationId
        }
      }
    }
  }
}
</script>
